import { render, staticRenderFns } from "./footerCard.vue?vue&type=template&id=c20ad978&scoped=true&"
import script from "./footerCard.vue?vue&type=script&lang=js&"
export * from "./footerCard.vue?vue&type=script&lang=js&"
import style0 from "./footerCard.vue?vue&type=style&index=0&id=c20ad978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20ad978",
  null
  
)

export default component.exports